import { IDeleteControleAguaUseCase } from "../../../presentation/useCases/delete/delete_controle_agua_use_case";
import { DeleteControleAguaRequestModel, DeleteControleAguaResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteControleAguaUseCase
 */

export class DeleteControleAguaUseCase implements IDeleteControleAguaUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async deleteControleAgua(model: DeleteControleAguaRequestModel): Promise<DeleteControleAguaResponseModel> {
    return await this.repository.deleteControleAgua(model);
  }
}
